const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  // BUR-12
  optionValueSelectionChange: 'option-value-selection-change',
  // ./BUR-12
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
